import { render } from "./register.vue?vue&type=template&id=00e1cfb4&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"

import "./register.vue?vue&type=style&index=0&id=00e1cfb4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-00e1cfb4"

export default script